import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import SearchForm from "../components/SearchForm";
import {
  Grid,
  Modal,
  Pagination,
  PaginationItem,
  Typography,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import ModalHelper from "../components/Generics/Modal/ModalHelper";
import axios from "axios";

const SigningCompleted = () => {
  /**
   * Controlla se l'utente è loggato, se non è loggato
   * viene reindirizzato alla pagina di login
   */
  // let access_token = Cookies.get("access_token");
  const access_token = localStorage.getItem("token");
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [responseEp, setResponseEp] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPagination, setCurrentPagination] = useState(1);
  //const [rateoPagination, setRateoPagination] = useState(5);
  const fData = new FormData();

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    setResponseEp(false); // Forza il ricaricamento dei dati

    // Aggiorna la query string
    if (term) {
      setSearchParams({ search: term });
    } else {
      setSearchParams({});
    }
  };

  let endpoint = process.env.REACT_APP_ENPOINT + "is-user-logged";

  const isUserLogged = async () => {
    //e.preventDefault();
    const response = await fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    if (result === "auth") {
      setIsLoggedIn(true);
    } else if (result === "guest") {
      window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
    }
    return result;
  };

  useEffect(() => {
    isUserLogged();
  }, []);

  if (isLoggedIn) {
    const getListCompleted = async () => {
      if (!responseEp) {
        let endpoint = process.env.REACT_APP_ENPOINT + "signing";

        const params = {
          status: "completed",
          page: currentPage
        };
        if (searchTerm) {
          params.search = searchTerm;
        }

        const response = await axios({
          method: "get",
          url: endpoint,
          params: params,
          headers: {
            Authorization: `Bearer ${access_token}`,
            Accept: "application/json",
          },
        });
        console.log("API Response:", response.data);
        const result = Array.isArray(response.data) ? response.data : (response.data.data || []);
        setData(result);
        setTotalPages(response.data.last_page || 1);
        setResponseEp(true);
      }
    };
    getListCompleted();
  }

  // overlay e modal alert visualizzazione mobile ruota display

  const [showRotateModal, setShowRotateModal] = useState(() => {
    const hasSeenModal = localStorage.getItem("rotateModalDismissed");
    return window.innerWidth < 600 && !hasSeenModal;
  });

  const handleCloseRotateModal = () => {
    localStorage.setItem("rotateModalDismissed", "true");
    setShowRotateModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const hasSeenModal = localStorage.getItem("rotateModalDismissed");
      if (window.innerWidth < 600 && !hasSeenModal) {
        setShowRotateModal(true);
      } else {
        setShowRotateModal(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setResponseEp(false); // Forza il ricaricamento con la nuova pagina
  };

  const lista = data.map((numero, index) => {
    const date = new Date(numero.created_at);
    const timestamp = date.getTime();
    const date2 = new Date(timestamp);
    const dateLocale = date2.toLocaleString("it-IT");

    return (
      <>
        <TableRow key={index}>
          <TableCell
            sx={{
              padding: "8px",
              whiteSpace: { xs: "nowrap", sm: "normal" },
            }}
            className="color-blue-dark"
          >
            <Typography className="text-table">{numero.id}</Typography>
          </TableCell>
          <TableCell
            sx={{
              padding: "8px",
              whiteSpace: { xs: "nowrap", sm: "normal" },
            }}
          >
            <a
              className="color-blue-dark text-table color-purple"
              href={"/paperwork/" + numero.id}
            >
              {numero.paperwork_name}
            </a>
          </TableCell>
          <TableCell
            sx={{
              padding: "8px",
              whiteSpace: { xs: "nowrap", sm: "normal" },
            }}
            className="color-blue-dark"
          >
            <Typography className="text-table">{dateLocale}</Typography>
          </TableCell>
          <TableCell
            sx={{
              padding: "8px",
              whiteSpace: { xs: "nowrap", sm: "normal" },
            }}
            className="color-blue-dark"
          >
            <Typography className="text-table">
              {" "}
              {numero.department_name}
            </Typography>
          </TableCell>
        </TableRow>
      </>
    );
  });

  return (
    <>
      <div style={{ marginTop: "120px" }}>
        <Grid container style={{ display: "flex", justifyContent: "center", marginTop: "230px" }}>
          <Grid item xs={10} md={10}>
            <Typography
              className="color-blue-dark"
              style={{
                fontSize: "22px",
                fontWeight: 600,
                marginBottom: "30px",
              }}
            >
              Signing chiusi
            </Typography>

            <div>
              {!responseEp ? null : (
                <>
                  <SearchForm onSearch={handleSearch} initialValue={searchTerm} />
                  {searchTerm && data.length === 0 ? (
                    <Typography
                      className={"color-blue-dark"}
                      sx={{
                        fontSize: { xs: "16px", md: "18px" },
                        fontWeight: 600,
                        marginTop: "30px",
                        marginBottom: "30px",
                      }}
                    >
                      Nessun risultato trovato.
                    </Typography>
                  ) : null}
                  <TableContainer
                    component={Paper}
                    sx={{ maxWidth: "100%", boxShadow: "none" }}
                  >
                    <Table sx={{ minWidth: 300 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              ID
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Nome operazione
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Data creazione
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Team
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{lista}</TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </div>
          </Grid>

          {!responseEp ? null : (
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: "30px", marginBottom: "30px" }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    sx={{
                      color: item.page === currentPage ? "#fff" : "#1b2838",
                      backgroundColor:
                        item.page === currentPage
                          ? "#1b2838 !important"
                          : "transparent",
                      "&:hover": {
                        backgroundColor:
                          item.page === currentPage
                            ? "primary.dark"
                            : "transparent",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          )}
        </Grid>
      </div>

      {showRotateModal && (
        <Modal
          open={showRotateModal}
          onClose={handleCloseRotateModal}
        >
          <div>
            <ModalHelper
              onClose={handleCloseRotateModal}
              modalObjectInfo={{
                infoTitle: "Visualizzazione",
                description:
                  "A seconda del tuo smartphone e delle tue preferenze, puoi ruotare lo schermo per una visione orizzontale.",
                descriptionBis: "",
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};
export default SigningCompleted;

/**
 *
 *
 *
 */
